function TheTitle()
{
    return (<h1 className="title">Calculator 9000</h1>)
}



export default TheTitle